module.exports = __webpack_public_path__ + "static/security2-e067e32541acae83861800cde1cfbaaf.png";